module.exports = __webpack_public_path__ + "static/media/0293_Medium.553c6182.jpg";